import { render } from "./LinkCorporate.vue?vue&type=template&id=3d6d3485&scoped=true"
const script = {}

import "./LinkCorporate.vue?vue&type=style&index=0&id=3d6d3485&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.29_vue@3.5.27_typescript@5.9.3__webpack@5.105.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6d3485"]])

export default __exports__